import { render, staticRenderFns } from "./CreditGroupAddModal.vue?vue&type=template&id=00bda63a&scoped=true&"
import script from "./CreditGroupAddModal.vue?vue&type=script&lang=js&"
export * from "./CreditGroupAddModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bda63a",
  null
  
)

export default component.exports